import { Zap, Briefcase, Building2, Shield } from "lucide-react";

export const ICONS     = [Zap, Briefcase, Building2, Shield];
export const ICON_BGS  = ["bg-slate-100", "bg-violet-50", "bg-teal-50", "bg-slate-100"];
export const ICON_COLS = ["text-slate-500", "text-violet-500", "text-teal-600", "text-slate-500"];
